import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as constants from "../../../constants/CONSTANT";
import FontAwesome from "react-fontawesome";
import { useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
// import "../template/custom.css";

/*********************
 * CP Code
 *******************/
import { PATHS } from "../../../constants/WebRouting";
import { Badge, Container } from "react-bootstrap";
/*********************
 * CP Code
 *******************/
const Sidebar = () => {
  const [sidebar, setSidebar] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [permissions, setPermissions] = useState();
  const location = useLocation();
  const Navigate = useNavigate();

  useEffect(() => {
    try {
      if (localStorage.getItem("token")) {
        let user = jwt_decode(localStorage.getItem("token"));
        setUserInfo(user);

        var perm = user.permissions
          .map(function (obj) {
            return obj.name;
          })
          .join(";");
        setPermissions(perm);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const toggleSidebar = () => {
    if (sidebar === false) {
      setSidebar(true);
      console.log(sidebar);
      document.querySelector("#sidebar").classList.toggle("active");
    } else {
      setSidebar(false);
      console.log(sidebar);
      document.querySelector("#sidebar").classList.toggle("active");
    }
  };

  return (
    <>
      <nav
        id="sidebar"
        className="sidebar card py-2 mb-4"
        style={{ backgroundColor: "white" }}
      >
        {/* left panel logo */}

        <div
          className="sidebar-header text-center"
          style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "10px" }}
        >
          <div className="pb-1">
            {userInfo.tenantcode === "ibs_cargo" ? (
              <img
                src="https://i.ibb.co/MyY2Hds3/gncm-final-logo-2.jpg" // GN Cargo
                style={{ width: "190px", height: "" }}
                alt=""
              />
            ) : userInfo.tenantcode === "ibs_ibirds" ? (
              <img
                // https://i.postimg.cc/NMkfwyX3/094A7281.jpg
                src="" // GN Trailer
                style={{ width: "190px", height: "" }}
                alt=""
              />
            ) : (
              <img
                src="https://i.ibb.co/Jj1JshKz/gnroadline-Logo-removebg-preview.png" // GN Roadlines (Fallback)
                style={{ width: "190px", height: "" }}
                alt=""
              />
            )}
          </div>
        </div>

        {/* Tabs List */}
        <ul
          className="nav flex-column list-unstyled components "
          id="tabs_navigation"
          style={{ fontWeight: "bold", borderTop: "1px solid #ddd" }}
        >
          {/* ****************** Home ****************** */}
          <li
            className={`${location.pathname.includes("/home") ? "active" : ""}`}
          >
            <Link to="/home">
              <i className="fa-solid fa-house mx-2"></i> Home
            </Link>
          </li>

          {permissions && permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
            <li>
              <a
                href="#masterSubMenu"
                data-toggle="collapse"
                aria-expanded="false"
                className="dropdown-toggle"
              >
                <i className="fa-solid fa-lock mx-2" size={18} />
                Master
              </a>
              <ul className="collapse list-unstyled" id="masterSubMenu">
                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/studentattendances")
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link to="/financialyears">
                      <div style={{ marginLeft: "20px" }}>
                        <i className="fa-solid fa-calendar mx-2" size={18} />{" "}
                        Financial Year
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/branches") ? "active" : ""
                      }`}
                  >
                    <Link to="/branches">
                      {" "}
                      <div style={{ marginLeft: "20px" }}>
                        <i className="fa-solid fa-building mx-2" size={18} />
                        Branch
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/items") ? "active" : ""
                      }`}
                  >
                    <Link to="/items">
                      {" "}
                      <div style={{ marginLeft: "20px" }}>
                        <i className="fa-solid fa-list-alt mx-2" size={18} />
                        Item
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/suppliers") ? "active" : ""
                      }`}
                  >
                    <Link to="/suppliers">
                      {" "}
                      <div style={{ marginLeft: "20px" }}>
                        <i className="fa-solid fa-industry mx-2" size={18} />
                        Supplier
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/clients") ? "active" : ""
                      }`}
                  >
                    <Link to="/clients">
                      {" "}
                      <div style={{ marginLeft: "20px" }}>
                        <i
                          className="fa-solid  fa-solid fa-user-group mx-2"
                          size={18}
                        />
                        Client
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/contacts") ? "active" : ""
                      }`}
                  >
                    <Link to="/contacts">
                      {" "}
                      <div style={{ marginLeft: "20px" }}>
                        <i
                          className="fa-solid  fa-solid fa-user mx-2"
                          size={18}
                        />
                        Agents (Broker)
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/transporters")
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link to="/transporters">
                      {" "}
                      <div style={{ marginLeft: "20px" }}>
                        <i className="fa-solid fa-truck mx-2" size={18} />
                        Transporter
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.indexOf(constants.MODIFY_ALL) >= 0 ? (
                  <li
                    className={`${location.pathname.includes("/drivers") ? "active" : ""
                      }`}
                  >
                    <Link to="/drivers">
                      <div style={{ marginLeft: "20px" }}>
                        <i className="fa-solid fa fa-child mx-2" size={18} />{" "}
                        Driver
                      </div>
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {/* {permissions && permissions.indexOf(constants.MODIFY_ALL) >= 0 ? ( */}
                <li
                  className={`${location.pathname.includes("/vehicles") ? "active" : ""
                    }`}
                >
                  <Link to="/vehicles">
                    <div style={{ marginLeft: "20px" }}>
                      <i className="fa-solid fa-truck mx-2" size={18} />{" "}
                      Vehicles
                    </div>
                  </Link>
                </li>

                <li
                  className={`${location.pathname.includes("/tyremasters") ? "active" : ""
                    }`}
                >
                  <Link to="/tyremasters">
                    <div style={{ marginLeft: "20px" }}>
                      <i className="fa-solid fa-steering-wheel mx-2" size={18} />{" "}
                      Tyre Master
                    </div>
                  </Link>
                </li>
                {/* ) : (
                ""
              )} */}
                <li>
                  <a
                    href="#sectionMangement"
                    data-toggle="collapse"
                    aria-expanded="false"
                    className="dropdown-toggle"
                  >
                    <i
                      className="fas fa-puzzle-piece mx-2"
                      aria-hidden="true"
                    ></i>
                    Location
                  </a>
                  <ul className="collapse list-unstyled" id="sectionMangement">
                    <li
                      className={`${location.pathname.includes("/countries") ? "active" : ""
                        }`}
                    >
                      <Link to="/countries">
                        <div style={{ marginLeft: "20px" }}>
                          <i className="fa-solid fa fa-globe mx-2" size={18} />{" "}
                          Country
                        </div>
                      </Link>
                    </li>
                    <li
                      className={`${location.pathname.includes("/states") ? "active" : ""
                        }`}
                    >
                      <Link to="/states">
                        <div style={{ marginLeft: "20px" }}>
                          <i className="fa-solid fa-flag mx-2"></i>
                          State
                        </div>
                      </Link>
                    </li>
                    <li
                      className={`${location.pathname.includes("/cites") ? "active" : ""
                        }`}
                    >
                      <Link to="/cites">
                        <div style={{ marginLeft: "20px" }}>
                          <i className="fa-solid fa-map mx-2"></i>
                          City
                        </div>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}
          {/* {Challan Master } */}
          <li>
            <a
              href="#challanMangement"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              <i className="fas fa-book mx-2" aria-hidden="true"></i>
              Challan Master
            </a>
            <ul className="collapse list-unstyled" id="challanMangement">
              <li
                className={`${location.pathname.includes("/challans") ? "active" : ""
                  }`}
              >
                <Link to="/challans">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-book-open mx-2" size={18} />{" "}
                    Challan List
                  </div>
                </Link>
              </li>
              {/* Advance Challan */}
              <li
                className={`${location.pathname.includes("/advancechallans") ? "active" : ""
                  }`}
              >
                <Link to="/advancechallans">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-book-open mx-2" size={18} />{" "}
                    Advance Challan List
                  </div>
                </Link>
              </li>
              {/* Advance Challan */}
              <li
                className={`${location.pathname.includes("/advancediesels") ? "active" : ""
                  }`}
              >
                <Link to="/advancediesels">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-truck mx-2" size={18} />{" "}
                    Diesel Challan List
                  </div>
                </Link>
              </li>

              {/* Challan Delivery */}
              <li
                className={`${location.pathname.includes("/challandelivery") ? "active" : ""
                  }`}
              >
                <Link to="/challandelivery">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fas fa-dolly mx-2" size={18} />{" "}
                    Challan Delivery List
                  </div>
                </Link>
              </li>
            </ul>
          </li>
          {/* {Challan Master } */}

          {/* {Driver Pay Master } */}
          <li>
            <a
              href="#driverPayMangement"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              <i className="fas fa-drivers-license mx-2" aria-hidden="true"></i>
              Driver Payment Master
            </a>
            <ul className="collapse list-unstyled" id="driverPayMangement">
              <li
                className={`${location.pathname.includes("/driverpayments") ? "active" : ""
                  }`}
              >
                <Link to="/driverpayments">
                  <div style={{ marginLeft: "12px" }}>
                    <i
                      className="fa-solid fa  fa-file-invoice mx-2"
                      size={18}
                    />{" "}
                    Driver Payment List
                  </div>
                </Link>
              </li>
              {/* <li
                        className={`${
                          location.pathname.includes("/driverpayments/ledger") ? "active" : ""
                        }`}
                      >
                        <Link to="/driverpayments/ledger">
                          <div style={{ marginLeft: "12px" }}>
                          <i className="fa-solid fa  fa-inr mx-1" size={18}/> Driver Ledger
                          </div>
                        </Link>
                  </li> */}
            </ul>
          </li>

          {/* {Challan Master } */}
          <li>
            <a
              href="#clientMangement"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              <i className="fas fa-receipt mx-2" aria-hidden="true"></i>
              Client Invoice Master
            </a>
            <ul className="collapse list-unstyled" id="clientMangement">
              <li
                className={`${location.pathname.includes("/clientinvoices") ? "active" : ""
                  }`}
              >
                <Link to="/clientinvoices">
                  <div style={{ marginLeft: "12px" }}>
                    <i
                      className="fa-solid fa  fa-file-invoice mx-2"
                      size={18}
                    />{" "}
                    Client Invoice List
                  </div>
                </Link>
              </li>
              <li
                className={`${location.pathname.includes("/clientinvoicepayments")
                  ? "active"
                  : ""
                  }`}
              >
                <Link to="/clientinvoicepayments">
                  <div style={{ marginLeft: "12px" }}>
                    <i className="fa-solid fa  fa-inr mx-1" size={18} /> Client
                    Invoice Payment
                  </div>
                </Link>
              </li>
            </ul>
          </li>
          {/* Purchase Management */}
            <li>
            <a
              href="#productChallanMangement"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              <i className="fas fa-shopping-cart mx-2" aria-hidden="true"></i>
              Purhcase Master
            </a>
            <ul className="collapse list-unstyled" id="productChallanMangement">
              <li
                className={`${location.pathname.includes("/categories") ? "active" : ""
                  }`}
              >
                <Link to="/categories">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa fa-truck mx-2" size={18} />{" "}
                    Category List
                  </div>
                </Link>
              </li>
              <li
                className={`${location.pathname.includes("/products") ? "active" : ""
                  }`}
              >
                <Link to="/products">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-product-hunt mx-2" size={18} />{" "}
                    Products List
                  </div>
                </Link>
              </li>
              {/* Purhcase Challan Master */}
              <li
                className={`${location.pathname.includes("/purchase-orders")
                  ? "active"
                  : ""
                  }`}
              >
                <Link to="/purchase-orders">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-book-open mx-2" size={18} />{" "}
                    Purhcase List
                  </div>
                </Link>
              </li>
              {/* Inventory */}
              <li
                className={`${location.pathname.includes("/inventory")
                  ? "active"
                  : ""
                  }`}
              >
                <Link to="/inventory">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-book-open mx-2" size={18} />{" "}
                    Inventory List
                  </div>
                </Link>
              </li>
  
            </ul>
          </li>
          {/* End Here */}
          {/* Trip Master Starts Here */}
          {/* {Trip Challan Master } */}
          <li>
            <a
              href="#tripChallanMangement"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              <i className="fas fa-book mx-2" aria-hidden="true"></i>
              Trip Challan Master
            </a>
            <ul className="collapse list-unstyled" id="tripChallanMangement">
              <li
                className={`${location.pathname.includes("/tripchallans") ? "active" : ""
                  }`}
              >
                <Link to="/tripchallans">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-book-open mx-2" size={18} />{" "}
                    Trip Challan List
                  </div>
                </Link>
              </li>
              {/* Trip Advance Challan */}
              <li
                className={`${location.pathname.includes("/tripadvancechallans")
                  ? "active"
                  : ""
                  }`}
              >
                <Link to="/tripadvancechallans">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-book-open mx-2" size={18} />{" "}
                    Trip Advance Challan List
                  </div>
                </Link>
              </li>
              {/*  Trip Advance Challan */}
              {/* <li
                className={`${
                  location.pathname.includes("/tripadvancediesels")
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/tripadvancediesels">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-truck mx-2" size={18} /> Trip
                    Diesel Challan List
                  </div>
                </Link>
              </li> */}

              {/* Trip Challan Delivery */}
              {/* <li
                              className={`${
                                location.pathname.includes("/tripchallandelivery") ? "active" : ""
                              }`}
                            >
                              <Link to="/tripchallandelivery">
                                <div style={{ marginLeft: "20px" }}>
                                <i className="fa-solid fa  fas fa-dolly mx-2" size={18}/> Trip Challan Delivery List
                                </div>
                              </Link>
                         </li> */}
            </ul>
          </li>

          {/* Tyre Starts Here */}
          {/* {Tyre Allotment } */}
          <li>
            <a
              href="#tyreChallanMangement"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              <i className="fas fa-book mx-2" aria-hidden="true"></i>
              Services Master
            </a>
            <ul className="collapse list-unstyled" id="tyreChallanMangement">
              <li
                className={`${location.pathname.includes("/service-orders") ? "active" : ""
                  }`}
              >
                <Link to="/service-orders">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-gear mx-2" size={18} />{" "}
                    Service Master List
                  </div>
                </Link>
              </li>
             
              {/*  Trip Advance Challan */}
              {/* <li
                className={`${
                  location.pathname.includes("/tripadvancediesels")
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/tripadvancediesels">
                  <div style={{ marginLeft: "20px" }}>
                    <i className="fa-solid fa  fa-truck mx-2" size={18} /> Trip
                    Diesel Challan List
                  </div>
                </Link>
              </li> */}

              {/* Trip Challan Delivery */}
              {/* <li
                              className={`${
                                location.pathname.includes("/tripchallandelivery") ? "active" : ""
                              }`}
                            >
                              <Link to="/tripchallandelivery">
                                <div style={{ marginLeft: "20px" }}>
                                <i className="fa-solid fa  fas fa-dolly mx-2" size={18}/> Trip Challan Delivery List
                                </div>
                              </Link>
                         </li> */}
            </ul>
          </li>
          {/* Reports */}
          <li
            className={`${location.pathname.includes("/tripchallans") ? "active" : ""
              }`}
          >
            <Link to="/taskreports">
              <div style={{ marginLeft: "5px" }}>
                <i className="fa-solid fa  fa-file mx-2" size={18} /> Reports
              </div>
            </Link>
          </li>
          {/* User Profile
          <li
            className={`${
              location.pathname.includes("/users") ? "active" : ""
            }`}
          >
            <Link to="/users">
              <div style={{ marginLeft: "5px" }}>
                <i className="fa-solid fa  fa-file mx-2" size={18} /> Users
              </div>
            </Link>
          </li>
          <li
            className={`${
              location.pathname.includes("/backup") ? "active" : ""
            }`}
          >
            <Link to="/backup">
              <div style={{ marginLeft: "5px" }}>
                <i className="fa-solid fa  fa-file mx-2" size={18} /> Backup
              </div>
            </Link>
          </li> */}

          <li
            className={`${location.pathname.includes("/myprofile") ? "active" : ""
              }`}
          >
            <Link to="/myprofile">
              <i className="fa-solid fa-key mx-2" size={18} />
              My Profile
            </Link>
          </li>
          {/* <Container>
            <img
              src={localStorage.getItem("myimage")}
              className=""
              style={{ height: "180px" }}
            />
            <Badge style={{ marginLeft: "48px" }}>
              {localStorage.username}
            </Badge>
          </Container> */}

          {/* Trip End Here */}

          <li></li>
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
